var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from './action-factory';
var CustomerTeamActions = /** @class */ (function (_super) {
    __extends(CustomerTeamActions, _super);
    function CustomerTeamActions() {
        return _super.call(this, 'CustomerTeam') || this;
    }
    Object.defineProperty(CustomerTeamActions.prototype, "REQUEST_REMOVE", {
        get: function () {
            return "[" + this.type + "][Request] Remove";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerTeamActions.prototype, "RESPONSE_SUCCESS_REMOVE", {
        get: function () {
            return "[" + this.type + "][Response][Success] Remove";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerTeamActions.prototype, "RESPONSE_FAIL_REMOVE", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Remove";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Revoke a user's permissions on the currently selected customer
     *
     * @param {{ id: string }} payload The member id to revoke permissions from
     * @returns
     * @memberof CustomerTeamActions
     */
    CustomerTeamActions.prototype.RequestRemove = function (payload) {
        return {
            type: this.REQUEST_REMOVE,
            payload: payload
        };
    };
    CustomerTeamActions.prototype.ResponseSuccessRemove = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_REMOVE,
            payload: payload
        };
    };
    CustomerTeamActions.prototype.ResponseFailRemove = function (payload) {
        return {
            type: this.RESPONSE_FAIL_REMOVE,
            payload: payload
        };
    };
    return CustomerTeamActions;
}(CareAppListActionFactory));
export var CustomerTeam = new CustomerTeamActions();
